<template>
  <section class="display">







  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'



export default {
  name: 'heroSection',
  data () {
    return {
      // mainImage: require('/static/c-lifting-2.jpg'),
      slideshow: {

        1: {
          id: 1,
          img: '../../static/sp1.jpg',
          left: 0,
          active: true },
        2: {
          id: 2,
          img: '../../static/sp2.jpg',
          left: '50vw',
          active: true }
          ,
        3: {
          id: 3,
          img: '../../static/sp3.jpg',
          left: '50vw',
          active: true }
          ,
        4: {
          id: 4,
          img: '../../static/sp4.jpg',
          left: '50vw',
          active: true }
          ,
        5: {
          id: 5,
          img: '../../static/sp5.jpg',
          left: '50vw',
          active: true }
          ,
        6: {
          id: 6,
          img: '../../static/sp6.jpg',
          left: '50vw',
          active: true }
      },
      benifits: false,
      benifitData: [
        'Adds structural stability',
        'Provides a continuous air barrier',
        'Prevents moisture infiltration',
        'Superior energy savings',
        'Minimizes insect and rodent penetration'
      ],
      typer: [
          "Licensed Applicator",
          "Over 30 Years Construction Experience",
          "Family Owned Business"
      ],
      whySprayFoam: false,
      title: null,
      button: null,
      link: null,
      alt: null,
      image: '',
      slideId: '',
      heroSection: [],
      payments: {
        1: '/static/visa.svg',
        2: '/static/master-card.svg',
        3: '/static/ae.svg',
        4: '/static/discover.svg',
      },
      services: {
        concrete: {
          name: 'Concrete Lifting',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        },
        sprayFoam: {
          name: 'Spray Foam',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        },
        Soil: {
          name: 'Soil Stablization',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        },
        Roof: {
          name: 'Spray Foam Roofing',
          desc: 'Spray foam insulation achieves a perfect fit every time eliminating voids and gaps between other building elements reducing air infiltration thus reducing energy loss. It doesn’t sag, settle or deteriorate like other conventional insulation.'
        }
      },
      editData: [],
      errors: [],
      showNav: false,
      editClicked: false
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
     this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    },
    slideshow(val) {
      alert(val)
    }
  },
  mounted() {
    window.addEventListener("hashchange", function () {
    window.scrollTo(window.scrollX, window.scrollY - 60);
    })
    this.$nextTick(() => {
      window.addEventListener('scroll', () => {
        this.windowHeight = window.pageYOffset

        window.pageYOffset >= 70 
        ? this.$parent.headerColor = '#111'
        : this.$parent.headerColor = 'rgba(0, 0, 0, 0.2)'
      });
    })
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    pickSlide(display, idx) {
      for (var items in this.slideshow) {
        if (this.slideshow[items].id > display.id ) {
            this.slideshow[items].left = "50vw"
            this.slideshow[items].active = false
        } else {
          this.slideshow[items].left = "-50vw"
          this.slideshow[items].active = false

        }
      }
        display.left = 0 
        display.active = true
    },
      arrowSlide(direction) {

        if (direction == "left") {

          for (var items in this.slideshow) {
              this.slideshow[ items - 1 ].active = true
              this.slideshow[items].left = "-50vw"
          }

        }

        if (direction == "right") {

          for (var items in this.slideshow) {
              this.slideshow[ items + 1 ].active = true
              this.slideshow[items].left = "50vw"
          }
          
        }


      }

  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;

  .footer-image {
      position: relative;
      width: 100%;
      left: 0;
      bottom: 0;
      margin: 2em auto 0 auto;
      text-align: left;
      img {
        width: 80%;
      }
    }

   .mobile-grid {
     display: flex;
     flex-direction: row;
     flex-flow: wrap;
     width: 100%;
     .mobile-photo {
       width: 90%;
       margin: 0 auto;
       img {
         width: 100%;
       }
     }
   }

  .service-parent {
    width: 90%;
    display: flex;
    flex-direction: row;
    padding: 2em 0;

    .service-child {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      h3 {
        font-size: 1.2vw;
      }
      
    }



    @media screen and (max-width: $break-small) {
        width: 98%;
        display: flex;
        flex-direction: row;
        flex-flow: wrap;
        padding: 2em 0;

        .service-child {
          width: 50%;
          display: flex;
          margin: 2em 0;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h3 {
            font-size: 14px;
            text-align: center;
          }
        }


    }
  }

  .service-icon {
    width: 100px;
    height: 100px;
    background-color: #eee;
    border-radius: 50%;
    cursor: pointer;
    transition: all .3s ease-in-out;
    transform: scale(1);
  }
  .service-icon:hover {
    background-color: #e9e9e9;
    transform: scale(1.2);
  }

  .slantRight {
    position: absolute;
    content: "";
    border-left: 100vw solid transparent;
    height: 0;
    width: 0;
    bottom: -1px;
    left: 0;
    z-index: 2;
}

  .slantLeft {
    position: absolute;
    content: "";
    border-left: 100vw solid transparent;
    height: 0;
    width: 0;
    top: -1px;
    left: 0;
    z-index: 2;
}

  .flex {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
  }
  .flex-align {
    width: 45%;
    margin: 1em auto;
    line-height: 1em;
    display: flex;
    flex-flow: column;
    align-items: left;
    text-align: left;
    font-size: 20px;
    color: #ddd;





    input {
      padding: 1em;
      background-color: rgb(30, 30, 30);
      border: none;
      outline: none;
      color: #eee;
      font-size: 18px;
      margin: 10px 0;
    }
    p {
      margin: 1em 0;
      line-height: 1.2em;
    }
  button {

    font-size: 16px;
    padding: 1em;
    width: 50%;
    margin: 3em 0 0 0;
    background-color: unset;
    color: #fff;
    font-weight: 700;
    font-family: 'avenir', sans-serif;
    letter-spacing: 1px;
    font-style: italic;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
    border: 2px solid #fff;
    border-radius: 50px;
    z-index: 1;
    overflow: hidden;
    outline: none;

    &:hover{
      border-color: #F38F00;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      height: 100%;
      left: 0;
      top: 0;
      transition: all .2s ease-in-out;
      z-index: -1;
      cursor: pointer;
    }
    &:hover:before {
      width: 100%;
      background-color: #F38F00;
    }

  }
      @media screen and (max-width: $break-small) {
        width: 90% !important;
      }
    /* background-color: red; */
  }


  .slide h2 {
    font-family: 'didot', serif;
    letter-spacing: .2em;
    text-transform: uppercase;
    font-weight: lighter;
  }




.overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
  background-image: url(../assets/icons/pattern.png);
  background-size: 5px;
  background-color: rgba(0, 0, 0, 0.35);
}

.slide h2 {
  font-size: 4em;
  padding: 2em 0 0 0;
  width: 50%;
  margin: 0 0 20px 100px;
  text-align: left;
  position: relative;
  color: #fff;
  z-index: 1;
}



.info button {
  margin-top: 8px;
  margin-right: 5px;
  width: 22%;
  height: 3vw;
  font-size: 14px;
  border: none;
  border-radius: 20px;
  font-weight: 300;
  letter-spacing: 1px;
  outline: none;
  transition: 0.15s all ease-in-out;
      outline: none;

}

.info button:hover {
  background-color: black;
  color:  #c1e529;
}

.push-up {
  margin-top: -35px;
}

.icon-nav {
  position: absolute;
  width: 80%;
  height: auto;
  top: 620px;
  left: 50%;
  margin-left: -40%;
  z-index: 2;
}
.page-section {
  width: 100%;
  padding: 1em 0 80px 0;
  position: relative;
  height: auto;
}
.sm-section {
  width: 100%;
  height: inherit;
  position: relative;
  padding: 2em 0 4em 0;
  display: flex;
  flex-flow: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 100;

  .payment {
    width: 100vw;
    height: inherit;
    padding: 2em 0;
    img {
      width: 12%;
    } 
  }

  @media screen and (max-width: $break-small) {
    .payment {
      width: 60%;
      height: inherit;
      padding: 2em 0;
      img {
        width: 50%;
      }
    }
  }
}

.bg-black {
  background-color: #111;
  color: white;
}
.bg-white {
  background-color: #fff;
  color: #111;
}
.bg-orange {
  color: white;
  position: relative;
  background-color: #F38F00;
  width: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  z-index: 100;
}
/* .bg-orange::before {
  content: '';
  position: absolute;
  top: -40px;
  background-image: url('/static/spray-foam-bg.svg');
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  height: 100%;
  z-index: 1000;
  pointer-events: none;
} */

/* .bg-orange::after {
  content: '';
  position: absolute;
  bottom: -340px;
  background-image: url('/static/spray-foam-bg-2.svg');
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  height: 100%;
  z-index: 2000;
  pointer-events: none;

} */

.border-left {
  padding: 0 0 5px 2em;
  border-left: 3px solid #fff;
}
// .service {
//   background-color: #ddd;
//   border-radius: 30px;
//   height: auto;
//   margin-right: 10px;
//   padding: 1em 1em;
// }
.service h4 {
  font-family: 'Roboto Slab', 'Avenir', sans-serif;
  font-size: 1.1em;
}
.service p {
  font-family: 'Avenir', sans-serif;
  font-size: 0.8em;
}

@media only screen and (max-width: 900px) {

  .hide-mobile {
    display: none;
  }

  .slider {
    height: 600px !important;
  }

  .slide {
    height: 600px;
    background-size: cover;
    background-position: center;
    -webkit-transform: translate3d(0,0,0) !important;
  }


  .info button {
      margin-top: 10px;
      margin-right: 5px;
      width: 70%;
      height: 10vw;
      font-size: 14px;
      border: none;
      border-radius: 20px;
      font-weight: 700;
  }



}
</style>

<style lang="scss">
  $break-small: 900px;

  @mixin transition {
  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      transition: all .3s #{$i * .1}s ease-in-out;
    }
  }
}

  .decor-right, .decor-left {
    position: absolute;
    top: 0;
    img {
      width: 150px;
    }
      @media screen and (max-width: $break-small) {
        img{
          width: 50px;
        }
      }
  }
  
  .decor-right {
    right: 2em;
  }

  .decor-left {
    right: 2em;
  }

  .slider {
    background-color: #111;
    height: 800px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 15%;

    &__slide {
      background-image: url(/static/home-splash.jpg);
      height: 800px;
      background-size: cover;
      background-position: center;
      -webkit-transform: translate3d(0,0,0) !important;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  &__slide h2 {
    font-size: 2.4em;
    width: 90%;
    margin: 0 auto 0 auto;
    text-align: left;
    font-weight: 900;
  }
  &__slide img {
    position: relative;
    z-index: 1;
    margin: -1em auto 1em auto;
    width: 60%;
  }
  &__slide p {
    color: #fff;
    margin: 0; 
    margin: 0 auto 2em auto;
    font-size: 1.7em;
    position: relative;
    z-index: 1;
  }

  &__slide button {
    font-size: 1.1em;
    padding: 1em 3em;
    width: auto;
    background-color: unset;
    color: #fff;
    font-weight: 700;
    font-family: 'avenir', sans-serif;
    letter-spacing: 1px;
    font-style: italic;
    text-transform: uppercase;
    position: relative;
    z-index: 1;
    border: 2px solid #fff;
    border-radius: 50px;
    z-index: 1;
    overflow: hidden;
    outline: none;


    &:hover{
      border-color: #F38F00;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      height: 100%;
      left: 0;
      top: 0;
      transition: all .2s ease-in-out;
      z-index: -1;
      cursor: pointer;
    }
    &:hover:before {
      width: 100%;
      background-color: #F38F00;
    }


  }

  .location {
    z-index: 5;
    display: flex;
    flex-direction: row;
    align-items: left;
    justify-content: left;
    padding: 5px;
    height: 60px;

      h3 {
        color: #fff;
        margin: 0;
        width: 80%;
      }
      img {
        width: 20%;
        max-width: 30px;
      }
    }


  @media screen and (max-width: $break-small) {
    &__slide {
      background-image: url(/static/home-splash.jpg);
      height: 600px;
      background-size: cover;
      background-position: center;
      -webkit-transform: translate3d(0,0,0) !important;

      img {    
        margin: 1em auto 0 auto;
         width: 90%;
      }

      p {
        color: #fff;
        margin: 0; 
        margin: 0 auto 2em auto;
        font-size: 1.2em;
        position: relative;
        z-index: 1;
      }
    }

  }
  }

  .slideshow {
    width: 100%;
    overflow-x: scroll;
    background-color: #111;
    bottom: 0;
    height: 12vh;
    position: absolute;
    z-index: 99999;
    display: flex;
    flex-direction: row;
    justify-content: center;
    // align-items: center;
    img {
      height: calc(12vh - 2px);
      // border-top: 2px solid #fff;
      border-right: 1px solid #fff;
      // border-bottom: 2px solid #fff;
      border-left: 1px solid #fff;

      width: auto;
    }
  }

  .pop-up {
    position: fixed;
    top: 95px;
    right: 30px;
    bottom: 50px;
    left: 30px;
    color: #111;
    background-color: rgba(255, 255, 255, 1);
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    -webkit-overflow-scrolling: touch;
    z-index: 100000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30vh;
    box-shadow: 0 0 30px #444;

    &::before {
      position: fixed;
      content: "";
      z-index: -20;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.35);
    }
    

    .pop-up-child {
      width: 100%;
      height: 100%;
      position: absolute;
      overflow-y: scroll;
      display: flex;
      flex-direction: row;
      top: 0;
      left: 0;
      z-index: 1;
      &::-webkit-scrollbar { width: 0 !important }
      .pop-section {
        width: 50%;
      }
      .image-container {
        background-color: #fff;
        overflow: hidden;
        position: relative;
        width: 50%;
        height: calc(100% - 12vh);
        // .arrow {
        //   position: absolute;
        //   top: 40%;
        //   width: 40px;
        //   z-index: 999999;
        //   img {
        //     width: 100%;
        //   }
        // }
        // .left-arrow {
        //   left: 15px;
        // }
        // .right-arrow {
        //   right: 15px;
        // }
        .scroll {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;

          .scroll-item {
            position: absolute;
            width: 100%;
            height: inherit;

            top: 0;
            left: 0;
            transition: all .25s ease-in-out;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 90%;
            }
          }

        }
        // display: flex;
        // flex-direction: row;

      }
      .info-container {
        position: relative;
        z-index: 1;
        background-color: #fff;

        h3 {
          font-size: 2em;
          text-align: left;
          width: 90%;
          margin: 1em auto;
        }

        ul {
          font-size: 14px;
          margin: 2em 0;
        }
      }
      @media screen and (max-width: $break-small) {
        flex-direction: column;
        overflow: scroll;
        background-color: #fff;
        .pop-section {
          width: 100%;
          overflow-y: scroll;
        }
        .image-container {
          width: 50%;
          margin: 0 auto;
        }
        
      }
    }


    &__exit {
    z-index: 999999;
    background-color: #111;
    border: 1px solid #aaa;
    color: #fff;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 5px;
    cursor: pointer;
    }

    h3 {  font-family: 'Roboto Slab', 'Avenir', sans-serif;
          font-size: 2em;
      }
    li {
      text-align: left;
      font-size: 1.4em;
      @include transition;
    }
    p {
      text-align: left;
      font-size: 1em;
      max-width: 90%;
      margin: 0 auto;
    }
    button { 
      font-size: 1.1em;
      padding: 1em 2em;
      width: 300px;
      background-color: unset;
      color: #fff;
      font-weight: 700;
      font-family: 'avenir', sans-serif;
      letter-spacing: 1px;
      font-style: italic;
      text-transform: uppercase;
      position: relative;
      z-index: 1;
      border: 2px solid #fff;
      border-radius: 50px;
      margin: 2em auto;
      
  }

  }

  .vue-typer {
  /* Styles for the vue-typer container
     e.g. font-family, font-size  */
 
  .custom.char {
    /* Styles for each character
       e.g. color, background-color */
 
    &.typed {
      color: #fff !important;
      margin: 0; 
      margin: 0 auto 0 auto;
      font-family: 'Roboto Slab', 'Avenir', sans-serif;
      font-size: 0.8em;
      font-weight: 500;
      position: relative;
      z-index: 1;
    }

  }
  .custom.caret {
    background-color: #fff;
    margin-left: 2px;
  }
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue